import { Component, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'app-home6',
  templateUrl: './home6.component.html',
  styleUrls: ['./home6.component.scss']
})
export class Home6Component implements OnInit, OnDestroy {
  ngOnInit(): void {
    document.body.classList.add('home6-page');
  }

  ngOnDestroy(): void {
    document.body.classList.remove('home6-page');
  }
}
